export enum CommittedClubEvent {
  NamesCopied = "Names Copied",
  ExportAttempted = "Export Attempted",
  ExportSuccess = "Export Success",
  ExportFailed = "Export Failed",
  MonthSelected = "Month Selected",
  NameSaved = "Name Saved",
  RulesSaved = "Rules Saved",
  StartMonthSaved = "Start Month Saved",
  Refreshed = "Refreshed",
  Closed = "Closed",
  SettingsSelected = "Settings Selected",
  BestPracticeGuideSelected = "Best Practice Guide Selected",
  StartMonthSelected = "Start Month Selected",
  RulesSelected = "Rules Selected",
  NameSelected = "Name Selected",
  CommittedClubDashboardOpened = "Committed Club Dashboard Opened",
  AppUninstalled = "App Uninstalled",
  AppInstalled = "App Installed",
  ConfigureSelected = "Configure Selected",
}
